import styled, { css } from 'styled-components';
import { themeColor } from '../../../theme/getters';
import { modalHeading, modalLink, smallParagraph } from '../../../theme/typography';
import { Input as InputBase } from '../input';
import { Button, BUTTON_MODAL_TYPE } from '../button';

export const Title = styled.h1`
  ${modalHeading};
  margin-top: 8px;
  margin-bottom: 48px;
  color: ${themeColor('white')};
`;

export const Input = styled(InputBase).attrs(() => ({
  containerStyles: css`
    padding-bottom: 16px;
  `,
}))`
  border-radius: 0;
`;

export const SubmitButton = styled(Button).attrs(() => ({
  theme: BUTTON_MODAL_TYPE,
}))`
  margin-top: 16px;
  box-shadow: none;
`;

export const BottomTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BottomText = styled.span`
  ${smallParagraph};
  color: ${themeColor('gray')};
  &:after {
    display: none;
  }
`;

export const BottomTextLink = styled.a`
  ${modalLink};
  color: ${themeColor('gray')};
  margin-left: 5px;
  display: ${({ withMargin }) => (withMargin ? 'block' : 'inline')};
  margin-bottom: ${({ withMargin }) => (withMargin ? 24 : 0)}px;

  &:after {
    background: ${themeColor('gray')};
  }
`;

export const Form = styled.form`
  margin: 32px 0;
  width: 100%;
`;
